import React from "react";
import { Title } from "../components";
import LogoLogin from "../components/header/LogoLogin";
import '../css/pages/Login.css';
import { WelcomeName } from "../components/header/WelcomeName";




class LoginSSRR extends React.Component {
  
  render(){
    return(
      <div
      style={{display: "flex",
        width: "1440px",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",}}>
        <div
          style={{display: "flex",
          padding: "150px 0px",
          flexDirection: "column",
          alignItems: "flex-start",
          gap: "10px"}}
          >
          <div style={{display: "flex",
          width: "1392px",
          justifyContent: "center",
          alignItems: "flex-end"}}>
            <div 
            style={{display: "flex",
            paddingLeft: "0px",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "flex-start",
            gap: "24px",
            flex: "1 0 0"}}>
              <div 
              style={{display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "flex-start",
                gap: "8px",
                alignSelf: "stretch"}}>
              <Title
              className="login-title"
              text="Plataforma de Recaudación"
      />
              </div>
          </div>
        <LogoLogin/>  
        </div>
      <WelcomeName/>
      </div>
      </div>
    )
  }
}
export default LoginSSRR;
